import * as yup from "yup";

const companyDetailScheme = yup.object().shape({
  firstName: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("First Name is required"),
  lastName: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("Last Name is required"),
  companyName: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("Company Name is required"),
  addressLine1: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("Address is required"),
  stateCode: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("State is required"),
  state: yup.string().nonNullable(true).trim().required("State is required"),
  city: yup.string().nonNullable(true).trim().required("City is required"),
  postalCode: yup
    .string()
    .nonNullable(true)
    .trim()
    .matches(/^\d{5}$/, "Invalid ZIP code")
    .required("ZIP is required"),
});

export default companyDetailScheme;
